import React from 'react';
import { PaginationTable } from '@ver-uds/react';
import { HiringSite, State } from 'eve-account-client';
import { Accordion } from '@ver-uds/uswds-react';
import { columns, rowActions } from './common';
import GroupAccordionHeader from './GroupAccordionHeader';
import OpenModalType from '../OpenModalType';

export type EnrollmentAccordionProps = {
  hiringSiteState: State;
  hiringSitesData?: HiringSite[];
  onModalOpen: (hiringSite: HiringSite, modalType: OpenModalType) => void;
};

const EnrollmentAccordion = ({
  hiringSiteState,
  hiringSitesData,
  onModalOpen,
}: EnrollmentAccordionProps): JSX.Element => {
  const hiringSites = hiringSitesData || [];
  const siteCount = hiringSitesData?.length || 0;

  if (siteCount === 0) {
    return <></>;
  }

  return (
    <>
      <GroupAccordionHeader siteCount={siteCount} hiringSiteState={hiringSiteState} />
      <Accordion.Content id={hiringSiteState.code}>
        <PaginationTable
          id={`${hiringSiteState.code}-hiring-sites-table`}
          sortable
          variant="default"
          columns={columns}
          data={hiringSites}
          rowActions={rowActions(onModalOpen)}
        />
      </Accordion.Content>
    </>
  );
};
export default EnrollmentAccordion;
